import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../language/keys';
import { itemCounterStyle } from './style';

type ItemsCounterProps = {
    counter: number,
    total: number,
}

const ItemsCounter = ({ counter, total }:ItemsCounterProps): JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Typography style={ itemCounterStyle.typography.style }>
      { translate(STRING_KEYS.OUT_OF, {
        counter,
        total,
      }) }
    </Typography>
  );
};

export default ItemsCounter;
